import { OnInit, Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmployeesComponet } from 'app/views/modales/employees/modal-employees.component';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoRetroactive } from 'app/shared/models/retroactive/dto-retroactive.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { RetroactiveService } from '../../retroactive.service';
import { PayrollService } from '../../payroll.service';
import { OrganizationService } from '../../organization/organization.service';
import { PositionService } from '../../quote/position.service';
import { SecurityService } from 'app/shared/services/security.service';
import { forEachChild } from 'typescript';
import { CustomerService } from '../../quote/customer.service';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-retroactives',
  styleUrls: ['retroactives.style.scss'],
  templateUrl: 'retroactives.template.html'
})
export class RetroactivesComponent implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formularios */
  private formRetroactive: FormGroup;
  private locale: string = 'es';
  /**Catalogos */
  private catalogRetroactiveReasons: IDtoCatalog[];
  private catalogCompanies: Observable<IDtoCatalog[]>;
  private catalogRequisitions: Observable<ISelect[]>;
  private catalogPayrollTypes: IDtoCatalog[];
  private catalogPayrolls: IDtoCatalog[];
  private employeeIds: number[];
  private amount: number;
  /**Modales */
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  private employee: IDtoEmployee;
  private hasEmployee = false;
  private currentDate = new Date();
  private retroactives = new Array() as IDtoRetroactive[];
  private employeesTem = new Array() as IDtoRetroactive[];
  private showRoles: any;
  private employeeIniId: string;
  private periodKeyNom: Date;
  private payrollId: number;
  private profile: string;
  private isOpenPeriod: boolean;
  constructor(private formBuilder: FormBuilder
    , private configGeneral: AppConfig
    , private spinner: NgxSpinnerService
    , private retroactiveService: RetroactiveService
    , private configurationService: ConfigurationService
    , private modalService: BsModalService
    , private identityService: IdentityService
    , private payrollService: PayrollService
    , private organizationService: OrganizationService
    , private positionService: PositionService
    , private securityService: SecurityService
    , private customerService: CustomerService) {
    this.showRoles = this.securityService.getUserRolesStorage();
    if (this.showRoles !== '') {
      this.employeeIniId = this.showRoles.employeeId;
      this.profile = this.securityService.getProfileStorage('Retroactives');
    }
    this.isOpenPeriod = true;
  }
  ngOnInit(): void {
    if (this.configurationService.isReady) {
      this.spinner.show();
      this.getCatalogs();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.spinner.show();
        this.getCatalogs();
      });
    }
    this.initializeFormRetroactive();
  }
  private getCatalogs(): void {
    this.catalogCompanies = this.organizationService.getCatalogCompanies();
    this.positionService.getCatalogPayrollTypes().subscribe(res => {
      this.catalogPayrollTypes = res;
    });
    this.spinner.hide();
  }
  private getRetroactives(payrollId: number): void {
    this.retroactiveService.getRetroactivesByPayrollIdAndBossId(payrollId, Number(this.employeeIniId)).subscribe(r => {
      this.employeesTem = r;
    },
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      });
    this.spinner.hide();
  }
  private initializeFormRetroactive() {
    this.formRetroactive = this.formBuilder.group({
      amount: [null, Validators.required],
      retroactiveReasonId: [null, Validators.required],
      observations: [null, [Validators.maxLength(500)]],
      employee: [null],
      companyId: [null],
      payrollTypeId: [null],
      payrollId: [null, Validators.required]
    });
  }
  private submitForm(): void {
    this.save();
  }
  private openModalEmployees() {
    if (this.formRetroactive.valid) {

        if (this.amount > 16500) {
          this.configGeneral.newToast('Validación', 'El monto ingresado excedio el limite', 'error');
          return;
        }

      const initialState = {
        module: 'Retroactives',
        employeeIds: this.employeeIds
      };
      this.modalRef = this.modalService.show(ModalEmployeesComponet
        , Object.assign({ initialState }, { class: 'modal-lg' }, this.configModal));
      this.modalRef.content.onClose.subscribe((result) => {
        if (result) {
          this.employee = result;
          this.formRetroactive.get('employee').setValue(this.employee.employeeName);
          this.hasEmployee = true;
          let employee = this.formRetroactive.value as IDtoRetroactive;

          let accumulated: number = 0;
          this.employeesTem.filter(a => a.retroactiveReasonId == this.formRetroactive.value.retroactiveReasonId).forEach(a => accumulated += +a.amount);
          accumulated = (accumulated + +employee.amount);

          let res = this.employeesTem.filter(a => a.retroactiveReasonId == this.formRetroactive.value.retroactiveReasonId && a.employeeId == this.employee.id)[0];
          if (res != undefined) {
            this.configGeneral.newToast('Validación', 'El empleado ya se agregó con el motivo de retroactivo', 'error');
            return;
          }
          employee.employeeId = this.employee.id;
          employee.employeeName = this.employee.employeeName;
          employee.retroactiveReason = this.catalogRetroactiveReasons.filter(a => a.id == this.formRetroactive.value.retroactiveReasonId)[0].name;
          employee.periodKeyNom = this.configGeneral.getLocalISOTime(this.periodKeyNom);
          employee.creationDate = this.configGeneral.getLocalISOTime(this.currentDate);
          employee.bossId = Number(this.employeeIniId);
          employee.status = 'add';
          employee.payrollId = this.formRetroactive.value.payrollTypeId;
          employee.payrollId = this.payrollId;
          this.employeesTem.push(employee);
        } else {
          this.hasEmployee = false;
        }
      });
    } else {
      this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
      this.configGeneral.touchedControls(this.formRetroactive);
    }
  }
  private removeRetroctive(item: IDtoRetroactive): void {
    if (item.id != undefined) {
      item.status = 'delete'
    } else {
      let index = this.employeesTem.indexOf(item)
      if (index > -1) {
        this.employeesTem.splice(index, 1);
      }
    }
  }
  private resetForm(): void {
    this.formRetroactive.get('amount').setValue(null);
    this.formRetroactive.get('retroactiveReasonId').setValue(null);
    this.formRetroactive.get('observations').setValue(null);
    this.employee = null;
    this.employeesTem = null;
    this.formRetroactive.get('companyId').setValue(null);
    this.formRetroactive.get('payrollTypeId').setValue(null);
    this.formRetroactive.get('payrollId').setValue(null);
    this.catalogPayrolls = null;
  }
  private changeCompany(): void {
    this.formRetroactive.get('payrollTypeId').setValue(null);
    this.formRetroactive.get('retroactiveReasonId').setValue(null);
    this.formRetroactive.get('payrollId').setValue(null);
    this.catalogRetroactiveReasons = null;
    this.isOpenPeriod = true;
    this.employeesTem = null;
    this.catalogPayrolls = null;
    (errMessage) => {
      this.spinner.hide();
      this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
    };
  }
  private getCatalogPayrolls(item: IDtoCatalog): void {
    if (item == null) {
      return;
    }
    this.spinner.show();
    this.formRetroactive.get('payrollId').setValue(null);
    this.formRetroactive.get('retroactiveReasonId').setValue(null);
    this.employeesTem = null;
    this.catalogPayrolls = null;
    this.payrollService.getCatalogPayrolls(this.formRetroactive.value.companyId, this.formRetroactive.value.payrollTypeId, this.profile).subscribe(x => {
      this.catalogPayrolls = x;
      this.spinner.hide();
    }),
      (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
      };
  }
  private changePayrolls(item: IDtoCatalog): void {
    if (item == null) {
      this.periodKeyNom = null;
      this.hasEmployee = false;
      this.employee = null;
      this.retroactives = null;
      this.employeesTem = null;
      return;
    }
    this.payrollService.validatePayrolldLock(this.formRetroactive.value.payrollId, this.profile).subscribe(res => {
      let result = res.data.toString().split(',');
      if (result[0] == "2" && result[1] == 'True') {
        this.isOpenPeriod = false;
        return;
      }
      else {
        this.isOpenPeriod = true;
        this.spinner.show();
        this.periodKeyNom = new Date(item.additional);
        this.payrollId = this.formRetroactive.value.payrollId;
        let resPayroll = this.catalogPayrolls.filter(a => a.id == this.formRetroactive.value.payrollId)[0];
        let str = resPayroll.name.split('-');

        this.retroactiveService.getCatalogRetroactiveReasonsByCustomerId(Number(str[str.length - 1])).subscribe(c => {
          this.catalogRetroactiveReasons = c;
          //this.spinner.hide();
        }),

          this.getRetroactives(this.formRetroactive.value.payrollId);
        this.payrollService.getEmployeeIds(item.id, Number(this.employeeIniId)).subscribe(x => {
          this.employeeIds = x;
          this.spinner.hide();
        }),
          (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
          };
      }
    });
  }
  private save(): void {
    this.spinner.show();
    this.retroactiveService.addRetroactives(this.employeesTem)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            let r = x.data as IDtoRetroactive[];
            r.forEach(r => {
              if (r.status == 'add') {
                this.addModuleLog(r.id, 'new');
              }
              if (r.status == 'delete') {
                this.addModuleLog(r.id, 'delete');
              }
            });
            this.resetForm();
          }
          this.spinner.hide();
        },
        (errMessage) => {
          this.spinner.hide();
          this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
  }
  private deleteRetroactive(item: IDtoRetroactive): void {
    this.retroactiveService.deleteRetroactive(item.id).subscribe(x => {
      if (x.isCorrect) {
        let index = this.retroactives.indexOf(item)
        if (index > -1) {
          this.retroactives.splice(index, 1);
          this.retroactives = [...this.retroactives];
        }
      } else {
        this.configGeneral.newToast('Error', x.message, 'error');
      }
    });
  }
  private addModuleLog(id: number, action: string): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'Retroactives';
    dto.module = 'retroactives';
    dto.action = action;
    dto.registryAffectedId = id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }

}
